import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Themthongkephuongtien from "components/Dangkiem/Themthongkephuongtien.js";
import Thongkephuongtientable from "components/Dangkiem/Thongkephuongtientable.js";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Config from "conFig.js";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
export default function Dangkiemthongkephuongtien() {
  const classes = useStyles();
  const [openthem, setOpenthem] = React.useState(false);
  const [phuongtien, setPhuongtien] = React.useState([]);
  const [thangnam, setThangnam] = React.useState(dayjs());
  const handleClose = () => {
    setOpenthem(false);
    getbaocao(thangnam);
  };
  const openthembc = () => {
    setOpenthem(true);
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getbaocao = () => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url =
      Config.backend +
      "/api/DangKiemVien/getslthdangkiempl14qd342025userthang?thang=" +
      thang +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setPhuongtien(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "15%" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Chọn tháng năm"
              value={thangnam}
              onChange={(newValue) => {
                setThangnam(newValue);
                getbaocao(newValue);
              }}
              format="MM/YYYY"
              slotProps={{ textField: { size: "small" } }}
              views={["month", "year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: "27px",
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl style={{ width: "12%", marginLeft: 10 }}>
          <Button
            color="success"
            variant="contained"
            style={{ height: 27 }}
            onClick={getbaocao}
          >
            Xem
          </Button>
        </FormControl>
        <FormControl style={{ width: "12%", marginLeft: 10 }}>
          <Button
            color="warning"
            variant="contained"
            style={{ height: 27 }}
            onClick={openthembc}
          >
            Cập nhật
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <div style={{ height: 500, width: "100%", marginTop: 10 }}>
          <Thongkephuongtientable phuongtien={phuongtien} />
        </div>
      </GridItem>
      <Modal
        open={openthem}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <GridContainer>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 10 }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={10}>
                      <FormControl style={{ width: "100%", marginTop: "10px" }}>
                        <h6
                          className={classes.cardTitleWhite}
                          style={{ marginTop: "-5px" }}
                        >
                          Cập nhật phương tiện
                        </h6>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={1}></GridItem>
                    <GridItem xs={12} sm={12} md={1}>
                      <FormControl style={{ width: "100%", marginTop: "1px" }}>
                        <CloseIcon onClick={handleClose} />
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                {thangnam && <Themthongkephuongtien thangnam={thangnam} />}
              </Card>
            </GridItemLogin>
            <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
          </GridContainer>
        </div>
      </Modal>
    </GridContainer>
  );
}
